import { render } from "./PageTitle.vue?vue&type=template&id=638c75e8"
const script = {}

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__